import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a href="#page-top">
            <img
              src="img/logoAndName.png"
              style={{ height: "90px" }}
              className="navbar-brand page-scroll"
              href="#page-top"
            />
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#introducing" className="page-scroll">
                Introducing
              </a>
            </li>
            <li>
              <a href="#Scope" className="page-scroll">
                Scope
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Use Cases
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Explore
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll">
                Team
              </a>
            </li>
            <li>
              <a href="https://docs.microsui.com" className="page-scroll">
                Docs
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
